import { FC } from 'react'
import CreateLinkNumberInput from '../../../../CreateLinkNumberInput'
import spclasses from '../../../../../SetCourseClassDirectionModal/purchase.module.css'

type StreamOneTimeAdditionalCourseFieldsProps = {
  price?: number | null
  onChangePrice: (price: number | null) => void
}

/** UI доп. курса stream_one_time: только цена. */
const StreamOneTimeAdditionalCourseFields: FC<
  StreamOneTimeAdditionalCourseFieldsProps
> = ({ price, onChangePrice }) => {
  return (
    <div className={spclasses.inputWithLabel}>
      <CreateLinkNumberInput
        className={spclasses.input}
        title="Стоимость покупки (в руб.)"
        min={0}
        placeholder={0}
        value={price}
        onChange={onChangePrice}
      />
    </div>
  )
}

export default StreamOneTimeAdditionalCourseFields
